module.exports = __webpack_public_path__ + "img/manufacturer.107c20bb.svg";